export default "__VITE_ASSET__Bvm0S10B__"